import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, closeDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import ReactQuill from 'react-quill';

const MessageForm = observer(class MessageForm extends React.Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.createThreadCallback = this.createThreadCallback.bind(this);
  }

  componentWillMount() {
    this.state = {
      slot1Date: null,
      slot2Date: null,
      slot3Date: null,
      content: null
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Auto focus text editor when reply button is clicked
    if(!prevProps.renderForm && this.props.renderForm) {
      this.refs.quill.focus();
    }
  }

  handleSlotChange(date, e, slot) {
    this.setState({
      [slot]: date
    })
  }

  handleContent(content) {
    this.setState({
      content
    });
  }

  handleSubmit() {
    const { MessageStore, SessionStore } = this.props.store;

    const date1 = moment(this.state.slot1Date).format('YYYY-MM-DD Z');
    const date2 = moment(this.state.slot2Date).format('YYYY-MM-DD Z');
    const date3 = moment(this.state.slot3Date).format('YYYY-MM-DD Z');

    const data = {
      initiatingUserSid: SessionStore.userData.userSid,
      courseSid: SessionStore.userData.courseSid,
      sessionRequest: this.props.sessionRequest || false,
      content: this.state.content
    }

    if(this.props.sessionRequest && date1 && date2 && date3) {
      data.dateOption1 = moment(`${date1} ${this.slot1Time.value}`, 'YYYY-MM-DD Z HH:mm').toISOString();
      data.dateOption2 = moment(`${date2} ${this.slot2Time.value}`, 'YYYY-MM-DD Z HH:mm').toISOString();
      data.dateOption3 = moment(`${date3} ${this.slot3Time.value}`, 'YYYY-MM-DD Z HH:mm').toISOString();
    }

    if(this.props.examSid) {
      data.examSid = this.props.examSid;
    }

    if(this.props.proctorApprovalSid) {
      data.proctorApprovalSid = this.props.proctorApprovalSid;
    }

    if(this.props.examSessionEventReportSid) {
      data.examSessionEventReportSid = this.props.examSessionEventReportSid;
    }

    if(this.props.proctorSid) {
      data.toProctorAccountUserSid = this.props.proctorSid;
    }

    if(this.props.toUserSid && !this.props.proctorSid) {
      data.toUserSid = this.props.toUserSid;
    }

    if(this.props.proctorLocationSid) {
      data.locationSid = this.props.proctorLocationSid;
    }

    // Send the form data
    if(data.content) {
      if(this.props.mode === 'create') {
        // Creating a new thread
        MessageStore.createThread(data, this.createThreadCallback);
      } else {
        // Replying to an existing thread
        data.source = 'messenger';
        data.fromProctorAccountUserSid = SessionStore.userData.sid;

        delete data.courseSid;
        delete data.examSid;
        delete data.examConfigurationSid;
        delete data.examSessionEventReportSid;
        delete data.initiatingUserSid;
        delete data.proctorApprovalSid;
        delete data.sessionRequest;
        delete data.toProctorAccountUserSid;
        delete data.toUserSid;
        delete data.locationSid;

        MessageStore.replyToThread(this.props.threadSid, data);
      }

      // Clear out the content
      this.setState({
        content: ''
      });

      this.props.parentThread.setState({
        renderForm: false
      })
    } else {
      const editor = document.querySelector('.quill');

      if(editor) {
        editor.className += ' error';
      }
    }
  }

  createThreadCallback() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;

    SessionStore.showToaster(translation.message_sent, 'success');
    closeDrawer(null, this.props.parent);
  }

  render() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;

    // Quill text editor toolbar options
    const modules = {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{'list': 'bullet'}, {'list': 'ordered'}]
      ]
    };

    if(this.props.renderForm) {
      return (
        <form
          className={`message-form ${SessionStore.backgroundLoading ? 'working' : ''}`}
          onSubmit={(e) => checkValidity(e, this.handleSubmit)}
          noValidate
        >
          <ul className="fields">
            <li>
              <ReactQuill
                modules={modules}
                onChange={(e) => {this.handleContent(e)}}
                ref="quill"
              />
            </li>
          </ul>

          <button className="btn" type="submit">{translation.send}</button>
        </form>
      )
    } else {
      return (
        <div className="inbox__init-reply">
          <button className="btn--link" onClick={this.props.showForm}>{translation.reply}</button> {translation.to_message}
        </div>
      )
    }
  }
})

export default translate('MessageForm')(MessageForm);


// WEBPACK FOOTER //
// ./src/app/components/Messages/MessageForm.js